<template>
  <page-section :title="$t('Integrations_Igt_Edraw_Mappings')">
    <el-button
      slot="controls"
      type="primary"
      icon="el-icon-circle-plus"
      @click="addRow"
    >
      {{ $t('Integrations_Igt_Create_Mapping') }}
    </el-button>

    <rest-list-editable
      :payload="fetchEndpoint"
      :add-endpoint="saveEndpoint"
      :filterable="false"
      :rules="rules"
      :pagination="false"
      ref="rest-list"
    >
      <rest-list-column
        prop="event_type"
        :title="$t('Integrations_Igt_Event')"
        :min-width="180"
        :editable="true"
        :sortable="false"
      >
        <template slot-scope="{ row }">
          {{ row.event_type }}
        </template>
        <template slot="input-edit" slot-scope="slot">
          <el-select
            v-model="slot.model.event_type"
            value-key="event_type"
            filterable
            remote
            :remote-method="autocompleteSearchEvents"
            :loading="searching"
            :allow-create="true"
            @focus="autocompleteSearchEvents()"
          >
            <el-option
              v-for="item in events"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </template>
      </rest-list-column>

      <rest-list-column
        prop="campaign_id"
        :title="$t('Integrations_Igt_Campaign')"
        :min-width="180"
        :editable="true"
        :sortable="false"
      >
        <template slot-scope="{ row }">
          {{ row.campaign_title || row.campaign_id }}
        </template>
        <template slot="input-edit" slot-scope="slot">
          <el-select
            v-model="slot.model.campaign_id"
            value-key="campaign_id"
            filterable
            remote
            :remote-method="autocompleteSearchCampaign"
            :loading="searching"
            @focus="autocompleteSearchCampaign()"
          >
            <el-option
              v-for="item in campaigns"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
      </rest-list-column>

      <rest-list-column-actions :editable="true">
        <template slot-scope="scope">
          <rest-list-action-delete :endpoint="deleteEndpoint(scope.row)" />
        </template>
      </rest-list-column-actions>
    </rest-list-editable>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import RestListEditable from '@/common/components/rest/RestListEditable'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import memoize from 'memoizee'

const fetchCampaigns = memoize(
  queryString =>
    RestApi(
      projectEndpoint({
        method: 'get',
        url: `campaigns`,
        params: {
          title: queryString,
          status_type: 'live_past_campaigns',
          trigger_type: 'api'
        }
      })
    ).then(({ data }) => data),
  { promise: true, maxAge: 1000 }
)

const fetchEvents = memoize(
  queryString =>
    RestApi(
      projectEndpoint({
        method: 'get',
        url: `integrations/igt/edraw-events`,
        params: {
          title: queryString,
          type: 'edraw'
        }
      })
    ).then(({ data }) => data),
  { promise: true, maxAge: 1000 }
)

export default {
  name: 'IgtOverview',

  components: {
    RestListEditable,
    RestListActionDelete,
    RestListColumnActions,
    PageSection,
    RestListColumn
  },

  props: {
    model: {
      required: false
    }
  },

  data() {
    return {
      campaigns: [],
      events: [],
      searching: false
    }
  },

  computed: {
    rules() {
      return {
        event_type: {
          required: true,
          trigger: 'blur'
        },
        campaign_id: {
          required: true,
          trigger: 'blur'
        }
      }
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations/igt/${this.$route.query.id}/mapping`
      })
    }
  },

  methods: {
    addRow() {
      this.$refs['rest-list'].addRow({ campaign_id: null, event_type: null })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `integrations/igt/${this.$route.query.id}/mapping`
      })
    },

    deleteEndpoint(row) {
      let eventType = encodeURIComponent(row.event_type)
      let campaignId = encodeURIComponent(row.campaign_id)

      return projectEndpoint({
        method: 'delete',
        url: `integrations/igt/${this.$route.query.id}/mapping/${eventType}/${campaignId}`
      })
    },

    autocompleteSearchCampaign(queryString) {
      this.searching = true
      fetchCampaigns(queryString).then(data => {
        this.campaigns = data
        this.searching = false
      })
    },

    autocompleteSearchEvents(queryString) {
      this.searching = true
      fetchEvents(queryString).then(data => {
        this.events = data
        this.searching = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/igt/IgtOverview.vue